<template>
  <SymbolDetail
    v-if="!isEmpty(symbol)"
    class="w-[400px] !h-auto"
    :style="style"
    :symbol="symbol"
    :is-loading-symbol="isLoadingSymbol"
    :portfolio-symbols="null"
    is-market-map
    vertical
  />
</template>
<script setup lang="ts">
import { toRef } from 'vue';
import { isEmpty } from '@libs/utils';

import { SymbolDetail, useLiveSymbolQuery } from '@/modules/symbol';

const props = defineProps<{
  isin: string;
  style?: {
    top: string;
    bottom: string;
    right: string;
    left: string;
    position: string;
    zIndex: number;
  };
}>();

const { isLoadingSymbol, symbol } = useLiveSymbolQuery(toRef(props, 'isin'));
</script>
